module.exports = __webpack_public_path__ + "static/media/kushner-attias.de03c658.png";